import { FormControlLabel, Checkbox } from "@mui/material";
import Box from "elements/Box";
import AutocompleteField from "elements/AutocompleteField";
import { useSnackbar } from "notistack";

export default function KinesiologistsFilters(props: any) {
  const { filters, setFilters } = props;
  const { enqueueSnackbar } = useSnackbar();

  const toggleMode = (key: "advanced_wound_care" | "online_advice", checked: boolean) => {
    const updated = { ...filters, [key]: checked };
    if (!updated.advanced_wound_care && !updated.online_advice) {
      enqueueSnackbar('Al menos uno de los filtros debe estar activo.', { variant: 'warning' });
      return;
    }
    setFilters(updated);
  };

  return (
    <Box className="filters">
      <span className="filter_title">Filtrar búsqueda</span>

      <div className="filter_section">
        <h3>Prestaciones</h3>
        <FormControlLabel
          className="filter_checkbox"
          control={
            <Checkbox
              checked={filters.advanced_wound_care}
              onChange={(e) => toggleMode("advanced_wound_care", e.target.checked)}
            />
          }
          label="Kinesiología a Domicilio"
        />
        <FormControlLabel
          className="filter_checkbox"
          control={
            <Checkbox
              checked={filters.online_advice}
              onChange={(e) => toggleMode("online_advice", e.target.checked)}
            />
          }
          label="Kinesiología en Consulta"
        />
      </div>

      <div className="filter_section">
        <h3>Ubicación</h3>
        <AutocompleteField
          label="Comunas"
          endpoint="/locations/comunas/list"
          renderValues={["label", "region"]}
          multiple={true}
          value={filters.locations}
          onChange={(data: any) => setFilters({ ...filters, locations: data ? data : [] })}
        />
      </div>

      <div className="filter_section">
        <h3>Habilidades</h3>
        <AutocompleteField
          label="Habilidades"
          endpoint="/skills/list"
          multiple={true}
          value={filters.skills}
          onChange={(data: any) => setFilters({ ...filters, skills: data ? data : [] })}
        />
      </div>
    </Box>
  );
}
